// @flow
import i18n from 'app/common/lib/i18n';
import { type ActivityUser } from 'app/common/redux/reducers/activityItems';

export const FEED_WIDTH = 656;
export const BOARD_HEADER_MAX_WIDTH = 774;
export const PIN_IMAGE_HEIGHT = 328;
export const PIN_SIZE = '474x';
export const CONTENT_WIDTH = 464;
export const MAX_NAME_CHAR_LENGTH = 60;
export const BIG_FONT_CHARACTER_LIMIT = 35;
export const MAX_CHAR_LENGTH = 170;

export const getTimeSinceText = (created_at: string) => {
  const time = new Date(created_at);
  const now = new Date();
  const difference = now.getTime() - time.getTime();

  const numSecondsBetween = Math.floor(difference / 1000);
  return numSecondsBetween < 60
    ? i18n._('now', 'timestamp for a comment or post that was created within the last minute')
    : i18n.getHumanizedTimesince(created_at, { isAbbreviated: true });
};

export const getNameToShow = (user: ActivityUser) => {
  const name = user.first_name || user.full_name || user.username;
  return name && name.length > MAX_NAME_CHAR_LENGTH
    ? name
        .substring(0, MAX_NAME_CHAR_LENGTH)
        .trim()
        .concat('...')
    : name;
};
